export default __webpack_public_path__ + "static/media/params.1260122d.PNG";